var _defs, _rect, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoLineChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -70.51,
    y1: 73.513,
    x2: -70.508,
    y2: 73.682,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#36adfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e57aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -69.165,
    y1: 72.013,
    x2: -69.163,
    y2: 72.182,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -67.999,
    y1: 72.68,
    x2: -67.996,
    y2: 72.849,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -66.999,
    y1: 71.68,
    x2: -66.996,
    y2: 71.849,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.477,
    y1: 0.969,
    x2: 0.49,
    y2: -0.043,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -101.577,
    y1: 100.803,
    x2: -101.34,
    y2: 100.709,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06c270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#019a57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -70.565,
    y1: 71.702,
    x2: -70.407,
    y2: 71.639,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -69.232,
    y1: 70.702,
    x2: -69.074,
    y2: 70.639,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -68.065,
    y1: 71.368,
    x2: -67.907,
    y2: 71.306,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -67.065,
    y1: 70.702,
    x2: -66.907,
    y2: 70.639,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ico_line_hart",
    transform: "translate(-437.15 -527.453)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 32,
    height: 32,
    transform: "translate(437.15 527.453)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ico_line_hart-2",
    "data-name": "ico_line_hart",
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_745",
    "data-name": "Ellipse 745",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(460.65 530.953)",
    opacity: 0.3,
    fill: "url(#linear-gradient)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_746",
    "data-name": "Ellipse 746",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(452.607 539.952)",
    opacity: 0.3,
    fill: "url(#linear-gradient-2)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_747",
    "data-name": "Ellipse 747",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(445.63 535.84)",
    opacity: 0.3,
    fill: "url(#linear-gradient-3)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_748",
    "data-name": "Ellipse 748",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(439.65 541.84)",
    opacity: 0.3,
    fill: "url(#linear-gradient-4)",
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54011",
    "data-name": "Path 54011",
    d: "M440.648,544.95a2,2,0,0,1,3.1-1.666l3.2-3.25a1.994,1.994,0,1,1,3.566-.441l3.718,1.906a1.99,1.99,0,0,1,1.375-.549,1.937,1.937,0,0,1,.887.209l5.395-6.271a1.994,1.994,0,1,1,1.763,1.064,1.968,1.968,0,0,1-1-.269L457.3,541.9a2.02,2.02,0,0,1,.3,1.051,1.991,1.991,0,0,1-1.982,2h-.012a1.992,1.992,0,0,1-1.994-1.988v-.012a2,2,0,0,1,.092-.6l-3.742-1.916a2,2,0,0,1-2.244.3l-3.3,3.309a2,2,0,0,1-1.766,2.908h-.012A2,2,0,0,1,440.648,544.95Z",
    fill: "url(#linear-gradient-5)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_745-2",
    "data-name": "Ellipse 745-2",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(461.581 543.774)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_765",
    "data-name": "Ellipse 765",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(460.581 542.782)",
    opacity: 0.3,
    fill: "url(#linear-gradient-7)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_746-2",
    "data-name": "Ellipse 746-2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(452.607 548.953)",
    opacity: 0.3,
    fill: "url(#linear-gradient-8)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_747-2",
    "data-name": "Ellipse 747-2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(445.63 544.839)",
    opacity: 0.3,
    fill: "url(#linear-gradient-9)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_748-2",
    "data-name": "Ellipse 748-2",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(439.65 548.953)",
    opacity: 0.3,
    fill: "url(#linear-gradient-10)",
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Group_46718",
    "data-name": "Group 46718",
    d: "M453.614,551.454a2,2,0,0,1,.133-.719l-3.529-2.071a1.99,1.99,0,0,1-2.861.334l-2.836,1.782a1.992,1.992,0,1,1-.564-.832l2.81-1.768a1.995,1.995,0,1,1,3.85-.728,2.338,2.338,0,0,1-.019.277l3.726,2.187a2,2,0,0,1,2.454-.08l4.941-3.664a1.989,1.989,0,1,1,.58.815l-4.886,3.625a1.993,1.993,0,1,1-3.8.842Z",
    transform: "translate(0 .5)",
    fill: "url(#linear-gradient-11)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoLineChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_line_chart.27df009cc748675548cf436657ffacbb.svg";